import { Component, Input } from '@angular/core';
import { SapiItemList, SapiItemListResponse } from 'src/app/models/amazon';
import { AmazonItemSearch } from 'src/app/models/amazon-item-search';

@Component({
    selector: 'amazon-item',
    templateUrl: './amazon-item.component.html',
    styleUrls: ['./amazon-item.component.css'],
    standalone: false
})
export class AmazonItemComponent {

  @Input() amazonItems: AmazonItemSearch;

}
